import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import youtubeImg from "../../assets/images/youtube.webp";
import Footer from "../Footer";

import Article from "../../../components/CommonCompnents/resourcePage/Article";
import SearchBtnGroup from "../../../components/CommonCompnents/resourcePage/SearchBtnGroup";
import Video from "../../../components/CommonCompnents/resourcePage/Video";
import "../../../assets/scss/components/resouces.scss";
import { useParams } from "react-router-dom";

const SearchResult = (props) => {
  const { search } = useParams();

  const [resouces, setResouces] = useState({
    articles: [],
    videos: [],
  });

  const getResoucesRes = (res) => {
    if (res && res.data) {
      if (res.data.articles || res.data.videos) {
        setResouces({
          articles: res.data.articles.slice(0, 3),
          videos: res.data.videos.slice(0, 2),
        });
      }
    }
  };

  useEffect(() => {
    // getResouces(getResoucesRes);
  }, []);
  return (
    <div>
      <div className="resoucesPage resouces_search_page">
        <div className="container">
          <div className="tradingAlgos">
            <div className="tradingAlgos_header">
              <h1>Search related to - {search}</h1>
            </div>

            <div>
              <div className="custom-row articleVideoWrap articalVedio_row">
                <div className="grid_item_1">
                  <div className="article">
                    <div>
                      <h5>Articles</h5>
                    </div>
                    <div className="article_section_wrap">
                      {resouces &&
                        resouces.articles &&
                        resouces.articles.map((article, i) => {
                          return <Article key={i} article={article} />;
                        })}
                    </div>
                    <div>
                      <button className="text_btn">
                        <Link to="/articals">View All Articles</Link>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="grid_item_2">
                  <div className="article videos">
                    <div>
                      <h5>Videos</h5>
                    </div>
                    <div className="article_section_wrap">
                      <div className="videoWraps">
                        {resouces &&
                          resouces.videos &&
                          resouces.videos.map((video, i) => {
                            return <Video key={i} video={video} />;
                          })}
                        {/* <Video
                          details={{
                            title: "How to get started using our free APIs",
                            videoLink:
                              "https://www.youtube.com/embed/PcNv86vzEhA",
                          }}
                        />
                        <Video
                          details={{
                            title: "Trading with APIs",
                            videoLink:
                              "https://www.youtube-nocookie.com/embed/CaVnFbgqSYg",
                          }}
                        /> */}
                      </div>
                    </div>
                    <div>
                      <button className="text_btn">
                        <Link to="/videos">View All Videos</Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="resouces_btn_section align_left">
              <p>Search for topics related to</p>
              <SearchBtnGroup />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SearchResult;
